// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"4243":"1e76084e","4451":"5069e4c9","7146":"3f14a8dd","7669":"0fe3a9f9"}[chunkId] + ".css";
};